"use strict";

var _classCallCheck = require("/Users/davidx/projects/unishell/wallet/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/davidx/projects/unishell/wallet/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/davidx/projects/unishell/wallet/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/davidx/projects/unishell/wallet/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/davidx/projects/unishell/wallet/node_modules/@babel/runtime/helpers/inherits");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Node_1 = __importDefault(require("./Node"));

var prosemirror_tables_1 = require("prosemirror-tables");

var breaks_1 = __importDefault(require("../rules/breaks"));

var HardBreak =
/*#__PURE__*/
function (_Node_1$default) {
  _inherits(HardBreak, _Node_1$default);

  function HardBreak() {
    _classCallCheck(this, HardBreak);

    return _possibleConstructorReturn(this, _getPrototypeOf(HardBreak).apply(this, arguments));
  }

  _createClass(HardBreak, [{
    key: "commands",
    value: function commands(_ref) {
      var type = _ref.type;
      return function () {
        return function (state, dispatch) {
          dispatch(state.tr.replaceSelectionWith(type.create()).scrollIntoView());
          return true;
        };
      };
    }
  }, {
    key: "keys",
    value: function keys(_ref2) {
      var type = _ref2.type;
      return {
        "Shift-Enter": function ShiftEnter(state, dispatch) {
          if (!prosemirror_tables_1.isInTable(state)) return false;
          dispatch(state.tr.replaceSelectionWith(type.create()).scrollIntoView());
          return true;
        }
      };
    }
  }, {
    key: "toMarkdown",
    value: function toMarkdown(state) {
      state.write(" \\n ");
    }
  }, {
    key: "parseMarkdown",
    value: function parseMarkdown() {
      return {
        node: "br"
      };
    }
  }, {
    key: "name",
    get: function get() {
      return "br";
    }
  }, {
    key: "schema",
    get: function get() {
      return {
        inline: true,
        group: "inline",
        selectable: false,
        parseDOM: [{
          tag: "br"
        }],
        toDOM: function toDOM() {
          return ["br"];
        }
      };
    }
  }, {
    key: "rulePlugins",
    get: function get() {
      return [breaks_1.default];
    }
  }]);

  return HardBreak;
}(Node_1.default);

exports.default = HardBreak;